/**
 * Endkundenrechner API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export enum AntragsfrageTyp {

    Freitext = 'Freitext',

    Freitextarea = 'Freitextarea',

    Dropdown = 'Dropdown',

    Adresse = 'Adresse',

    Email = 'Email',

    Telefonnummer = 'Telefonnummer',

    Datum = 'Datum',

    Checkbox = 'Checkbox',

    Bankverbindung = 'Bankverbindung',

    Number = 'Number',

    Fahrzeugkennzeichen = 'Fahrzeugkennzeichen',

    Vorversicherer = 'Vorversicherer',

    LandIso3166 = 'LandIso3166',

    SteuerId = 'SteuerId',

    Berufsliste = 'Berufsliste'
}

